// extracted by mini-css-extract-plugin
export default {"date":"DateTime_date__sTvue","dateTime":"DateTime_dateTime__huDO4"};